module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/left-3-ef379977a476c37ae3b9e91abe11d1c8.svg";